module.exports = __webpack_public_path__ + "static/img/dajiao_education.0392f38.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dajiao_education.jpg
// module id = GcHC
// module chunks = 1